module.exports = __webpack_public_path__ + "static/Poster_Close-up_2-5751955a96551d2a59875e3831036317.png";